import React, { FC, ReactElement } from 'react';
import { Box, TextField } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';

// Import custom components
import CardAccordion from '../../layouts/CardAccordion/CardAccordion';
import HelperTextFields from '../../utilities/HelperTextFields/HelperTextFields';
import { updateMetaFields } from '../../../store/actions/postFormsActions/metaFieldsUpdatesAction';
import { Post } from '../../../store/reducers/postReducers/postReducer';
import { RootState } from '../../../store/reducers';

export default function TwitterOptions(): ReactElement<FC> {
  // Decalre the dispatch method
  const dispatch = useDispatch();

  // Select the post reducer
  const post: Post = useSelector((state: RootState) => state.postReducer);

  return (
    <CardAccordion heading="Twitter Card">
      <Box display="flex" flexDirection="column" sx={{ width: '100%' }}>
        <TextField
          label="Twitter Title"
          placeholder="Twitter Title"
          variant="outlined"
          value={post.metaOptions?.metaValue.twitterTitle || ''}
          sx={{
            marginBottom: '1.5rem',
          }}
          onChange={(e) =>
            dispatch(
              updateMetaFields({
                twitterTitle: e.target.value,
              })
            )
          }
          fullWidth
          helperText={
            <HelperTextFields helperText="The title of your article without any branding such as your site name." />
          }
        />

        <TextField
          label="Description"
          sx={{
            marginBottom: '1.5rem',
          }}
          placeholder="Description"
          variant="outlined"
          fullWidth
          multiline
          value={post.metaOptions?.metaValue.twitterDescription || ''}
          onChange={(e) =>
            dispatch(
              updateMetaFields({
                twitterDescription: e.target.value,
              })
            )
          }
          minRows={4}
          helperText={
            <HelperTextFields helperText="A brief description of the content" />
          }
        />
      </Box>
    </CardAccordion>
  );
}
